import { Grid } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import {
    FilterContainer,
    FilterGroupContainer,
} from '../../../StandardApplicationEntrypoint/CarListingPage/CarFilter/ui';
import CarModelFilter from './CarModelFilter';
import CarSubmodelFilter from './CarSubmodelFilter';
import DailyRateFilter from './DailyRateFilter';
import PeriodFilter from './PeriodFilter';

export const Container = styled.div`
    & h5.ant-typography {
        font-size: 20px;
    }

    & > div:not(:last-child) {
        margin-bottom: 50px;
    }
`;

const CarFilterContent = () => {
    const { t } = useTranslation(['core']);
    const screens = Grid.useBreakpoint();

    return (
        <FilterContainer
            $leftBordered={screens.md && t('core:orientation') === 'ltr'}
            $rightBordered={screens.md && t('core:orientation') === 'rtl'}
            $source="mobility"
        >
            <Container>
                {screens.md && (
                    <FilterGroupContainer>
                        <PeriodFilter />
                    </FilterGroupContainer>
                )}
                <FilterGroupContainer>
                    <CarModelFilter />
                </FilterGroupContainer>
                <FilterGroupContainer>
                    <CarSubmodelFilter />
                </FilterGroupContainer>
                <FilterGroupContainer>
                    <DailyRateFilter />
                </FilterGroupContainer>
            </Container>
        </FilterContainer>
    );
};

export default CarFilterContent;
